var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModeration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.96875,
    y: 1.96191,
    width: 19.8555,
    height: 1.17647,
    transform: "rotate(45 3.96875 1.96191)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 10.4962V10.9119C9.44761 10.5943 8.76526 10.4708 8.04173 10.7237C7.25349 11.0061 6.64761 11.7061 6.50643 12.5296C6.44117 12.9001 6.46556 13.2809 6.57757 13.6401C6.68959 13.9993 6.88596 14.3265 7.15028 14.5943C7.4146 14.862 7.73919 15.0627 8.0969 15.1793C8.45462 15.296 8.83506 15.3253 9.20643 15.2649C10.3594 15.0825 11.177 14.0237 11.177 12.8531V11.6727L10.0006 10.4962ZM11.177 8.34054V7.059H12.3535C13.0006 7.059 13.53 6.52958 13.53 5.88253C13.53 5.23547 13.0006 4.70605 12.3535 4.70605H11.177C10.53 4.70605 10.0006 5.23547 10.0006 5.88253V7.16407L11.177 8.34054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8235 10C18.8235 14.8731 14.8731 18.8235 10 18.8235C5.1269 18.8235 1.17647 14.8731 1.17647 10C1.17647 5.1269 5.1269 1.17647 10 1.17647C14.8731 1.17647 18.8235 5.1269 18.8235 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -3,
    y: -3,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModeration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moderation.49154c022d72200d2af664c10b9d7226.svg";